import { render } from "./Reserves.vue?vue&type=template&id=5627edae"
import script from "./Reserves.vue?vue&type=script&lang=js"
export * from "./Reserves.vue?vue&type=script&lang=js"
script.render = render

export default script